// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstatausdt } from "../../../icons/full/build/icon-stkstatausdt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatausdtIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstatausdt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatausdtIcon.displayName = 'StkstatausdtIcon';
}

export default StkstatausdtIcon;